import { Container, Layout, Text } from "@certn/cascadia-react";
import { Trans } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { useStyles } from "./styles";
import { AppFooter } from "../../components/AppFooter";
import { AppHeader } from "../../components/AppHeader";

export function RequestDeclined() {
  const [searchParams] = useSearchParams();
  const teamName = searchParams.get("team_name");
  const styles = useStyles();

  return (
    <Layout
      layout="auth"
      header={<AppHeader hideSettings showLoginButton />}
      footer={<AppFooter />}
    >
      <Container>
        <div className={styles.container}>
          <Text as="h2" style="form/page-title">
            <Trans>Request declined</Trans>
          </Text>
          <div>
            <Text style="form/body-primary" color="text-weak">
              <Trans>
                You have declined your background check request from{" "}
                {{ teamName }}, and can close this window.
              </Trans>
            </Text>
          </div>
        </div>
      </Container>
    </Layout>
  );
}
